import type { AgentRole } from '../models/entities/agent-role.model';

export type AgentRoleClaimResult =
  | { status: 'ok'; role: AgentRole }
  | { status: 'none' };

const ROLE_BY_NORMALIZED_NAME: Readonly<Record<string, AgentRole>> = {
  admin: 'Admin',
  manager: 'Manager',
  supervisor: 'Supervisor',
  detection: 'Detection',
  escalation: 'Escalation',
  'end-to-end': 'End-to-End',
};

/**
 * Maps Hub role claims to the product role used by EventQ.
 * Only "EventQ <role>" forms are accepted; the first valid claim wins.
 */
export function resolveAgentRoleFromClaims(claims: readonly string[]): AgentRoleClaimResult {
  for (const claim of claims) {
    const normalized = claim.trim().replace(/\s+/g, ' ').toLowerCase();
    if (!normalized.startsWith('eventq ')) {
      continue;
    }

    const role = ROLE_BY_NORMALIZED_NAME[normalized.slice(7)];
    if (role) {
      return { status: 'ok', role };
    }
  }

  return { status: 'none' };
}
